module.exports = __webpack_public_path__ + "img/Workflow-ability-03.3c5b644f.png";